// The customer's signature accepting the work (QA-727): who signed and when, where, and the pad, on
// the job, its invoice and the customer's history. The pad's link is the server's short-lived one.
import { useId } from 'react';
import { PAD_ON_ITS_WAY, signedWhere, signedWords, type AcceptanceSignature } from './signed-model.ts';
import './signed.css';

/** One signature's pad: the picture, or why it isn't here yet. */
export function SignaturePad({
  s,
  small = false,
}: {
  s: Pick<AcceptanceSignature, 'signerName' | 'imageUrl'>;
  small?: boolean;
}) {
  return s.imageUrl ? (
    <img
      className={`signed-pad${small ? ' sm' : ''}`}
      src={s.imageUrl}
      alt={`${s.signerName}’s signature`}
      loading="lazy"
    />
  ) : (
    <p className="muted small">{PAD_ON_ITS_WAY}</p>
  );
}

/** The signatures on a job or an invoice; nothing at all when there are none. */
export function SignedForWork({
  signatures,
  timeZone,
  withInvoice = false,
}: {
  signatures: readonly AcceptanceSignature[];
  timeZone: string;
  /** Say which invoice each is on (a job's sheet). */
  withInvoice?: boolean;
}) {
  const title = useId();
  if (!signatures.length) return null;
  return (
    <section className="job-sect signed-work" aria-labelledby={title}>
      <h3 id={title}>Customer’s signature</h3>
      <ul className="signed-list">
        {signatures.map((s) => (
          <li key={s.signatureId}>
            <p>{signedWords(s, timeZone)}</p>
            <p className="muted small">{signedWhere(s, withInvoice)}</p>
            <SignaturePad s={s} />
          </li>
        ))}
      </ul>
    </section>
  );
}
